import { Helmet } from 'react-helmet-async';
import { SITE_DEFAULT_OG_IMAGE, SITE_NAME, SITE_URL } from '@/seo/siteConfig';
import { buildHomeJsonLd, getHomeSeo } from '@/seo/homeRoutesMeta';

type Props = {
  pathname: string;
};

export default function HomeSeo({ pathname }: Props) {
  const seo = getHomeSeo(pathname);
  const normalized =
    pathname === '' || pathname === '/'
      ? '/'
      : pathname.replace(/\/+$/, '') || '/';
  const canonical = normalized === '/' ? `${SITE_URL}/` : `${SITE_URL}${normalized}`;

  const jsonLd = buildHomeJsonLd(pathname, seo);

  return (
    <Helmet prioritizeSeoTags>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="geo.region" content="TR" />
      <meta name="geo.placename" content="Türkiye" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={SITE_DEFAULT_OG_IMAGE} />
      <meta property="og:image:alt" content={`${SITE_NAME} — kombi servisi`} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={SITE_DEFAULT_OG_IMAGE} />

      <link rel="alternate" hrefLang="tr" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />

      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
